module.exports = __webpack_public_path__ + "static/img/winter_banner.7449d467.jpg";